const FORM_INDEX = {
    PERSONAL_INFO: 0,
    RESIDENCE_INFO: 1,
    EMPLOYMENT_INFO: 2,
    JOINT_INFO: 3,
};

export { FORM_INDEX };
export default { FORM_INDEX };



// WEBPACK FOOTER //
// ./src/constants/financing.js